import { render, staticRenderFns } from "./PDPV3.vue?vue&type=template&id=473c6f1e&scoped=true"
import script from "./PDPV3.vue?vue&type=script&lang=js"
export * from "./PDPV3.vue?vue&type=script&lang=js"
import style0 from "./PDPV3.vue?vue&type=style&index=0&id=473c6f1e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "473c6f1e",
  null
  
)

export default component.exports